import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';

interface EmptyStateProps {
  message: string;
  height?: string | number;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  height = '50vh'
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height }}>
      <Typography variant="h6" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY }}>
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyState;